<template>
  <div>
    <section>
      <h1>Re-upload logos</h1>
      <div>
        <button class="is-primary" @click="convertAll">
          Start Conversion
        </button>
      </div>

      <div v-if="converting">
        <p>Company {{ companiesConverted }}/{{ companies.length }} Converted</p>
      </div>

      <div>
        <ul>
          <li v-for="site in sitesConverted" :key="site.id">{{ site }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData, readCompanySiteData, updateCompanySiteData} from '@/lib/sites'

export default {
  name: 'admin-replace-logos',

  mixins: [page, pagination],

  data() {
    return {
      converting: false,
      companiesConverted: 0,
      success: false,
      steppingThrough: false,
      companies: [],
      sitesConverted: [],
      company: {},
      site: {},
      selectedSite: {},
      siteId: '',
      sites: [],
      page: {},
      list: {},
      lists: [],
      listTypes: [],
      errors: {},
      siteGalleries: [],
      galleryId: '',
      basicGalleryId: ''
    }
  },

  computed: {
    ...mapGetters(['sessionToken'])
  },

  methods: {
    getData() {
      readCompaniesData({page: 1, page_size: 250}).then(({data, page}) => {
        this.companies = data
        this.pageData = page
      })
    },

    convertAll() {
      this.converting = true

      this.companies.forEach((company, index) => {
        window.setTimeout(() => {
          this.getSites(company.id)
          this.companiesConverted++
        }, 1000 * index)
      })
    },

    getSites(companyId) {
      readCompanySitesData(companyId, {page: 1, page_size: 250}).then(
        ({data}) => {
          let sites = data

          if (sites.length) {
            sites.forEach((site, index) => {
              window.setTimeout(() => {
                this.handleContactConversion(companyId, site.id, site)
                this.siteId = site.id
              }, 1000 * index)
            })
          }
        }
      )
    },

    handleContactConversion(companyId, siteId, site) {
      readCompanySiteData(companyId, siteId).then(({data}) => {
        let theSite = data

        if (theSite.logo_versions.length > 0) {
          let url = theSite.logo_versions[0].url.split('?')[0]
          let img = {logo: url}

          updateCompanySiteData(companyId, theSite.id, img).then((data) => {})
        }
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
